export default "<p>\r\n  comparative-statement-allviews works!\r\n</p>\r\n"